import { combine, persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export const saveKey = 'invite-code';

// store
export const useInviteCodeStore = createWithEqualityFn(
  persist(
    combine(
      {
        inviteCode: '',
      },
      set => {
        return {
          setInviteCode(inviteCode: string) {
            set({ inviteCode });
          },
        };
      }
    ),
    { name: saveKey }
  ),
  shallow
);
